'use strict';

angular.module('TurneroApp').component('coLlamadorConfiguracion', {
    bindings: {
        centroAtencionSeleccionado: '<',
        centroAtencionCallback: '&'
    },
    controller: [
        'llamadorService',
        'TurneroAppConstant',
        'utilsService',
        function (llamadorService, TurneroAppConstant, utilsService) {
            var ctrl = this;

            ctrl.configuracion = false;
            ctrl.listaTimbres = TurneroAppConstant.TimbresArray;
            ctrl.llamador = {};

            ctrl.$onInit = function () {
                createjs.Sound.volume = 0.25;

                for (var i in ctrl.listaTimbres) {
                    if (ctrl.listaTimbres[i].Id > 0) createjs.Sound.registerSound("assets/sounds/" + ctrl.listaTimbres[i].Text + '.mp3', ctrl.listaTimbres[i].Text);
                }
            }

            ctrl.$onChanges = function () {
                if (ctrl.centroAtencionSeleccionado) {
                    ctrl.configuracion = true;
                    llamadorService.Configuracion_Llamador({
                        'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                    }).$promise.then(function (data) {
                        ctrl.llamador = data;
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
            };

            ctrl.guardarConfiguracion = function (item) {

                if (item.Id_Llamador != null) {
                    switch (ctrl.llamador.grupoIdentificador) {
                        case 'Nombre':
                            ctrl.llamador.Mostrar_Nombre = 'S';
                            ctrl.llamador.Mostrar_DNI = 'N';
                            ctrl.llamador.Mostrar_Ticket = 'N';
                            break;
                        case 'Dni':
                            ctrl.llamador.Mostrar_Nombre = 'N';
                            ctrl.llamador.Mostrar_DNI = 'S';
                            ctrl.llamador.Mostrar_Ticket = 'N';
                            break;
                        case 'Ticket':
                            ctrl.llamador.Mostrar_Nombre = 'N';
                            ctrl.llamador.Mostrar_DNI = 'N';
                            ctrl.llamador.Mostrar_Ticket = 'S';
                            break;
                        default:
                            ctrl.llamador.Mostrar_Nombre = 'S';
                            ctrl.llamador.Mostrar_DNI = 'N';
                            ctrl.llamador.Mostrar_Ticket = 'N';
                            break;
                    }

                    llamadorService.update(item).$promise.then(function (data) {
                        sweetAlert("Modificar Configuraciones", "La configuración se modificó correctamente", "success");
                        ctrl.loginReload();
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                } else {
                    sweetAlert("Error Configuración.", "No existen valores de configuración para este Centro de atención", "error");
                }
            }

            ctrl.loginReload = function () {

                ctrl.centroAtencionCallback({
                    centroAtencionSeleccionado: null
                });

            };

            ctrl.reproducirTimbre = function () {
                createjs.Sound.play(ctrl.llamador.N_Timbre);
            }
        }
    ],
    template: require('./llamadorConfiguracion.html')
});



// WEBPACK FOOTER //
// ./app/components/llamador/llamadorConfiguracionComponent.js